"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddItemPriceOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var AddItemPriceOutputWidget = /** @class */ (function (_super) {
    __extends(AddItemPriceOutputWidget, _super);
    function AddItemPriceOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddItemPriceOutputWidget.prototype.render = function () {
        var _this = this;
        var newItems = this.props.interaction.valuableItems.filter(function (item) { return !(_this.props.interaction.uistate.itemIds && _this.props.interaction.uistate.itemIds.includes(item.valuableItemId)); });
        window.sessionStorage.removeItem("mtaAddItemDescriptions");
        window.sessionStorage.setItem("mtaAddItemDescriptions", JSON.stringify(newItems.map(function (item) { return item.description; })));
        return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
            React.createElement("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium)),
            React.createElement.apply(React, __spreadArray(["div", null,
                "to add"
            ], newItems.map(function (item, index, array) {
                if (index === array.length - 1) {
                    return React.createElement("span", { key: index },
                        React.createElement("b", { className: "font-weight-semi-bold" },
                            " ",
                            item.description));
                }
                return React.createElement("span", { key: index },
                    React.createElement("b", { className: "font-weight-semi-bold" },
                        " ",
                        item.description),
                    " and");
            }), false))));
    };
    return AddItemPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.AddItemPriceOutputWidget = AddItemPriceOutputWidget;
//# sourceMappingURL=AddItemPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/AddItemPriceOutputWidget.js
// module id = 2570
// module chunks = 0